import { Component } from '@angular/core';
import { MessageViewComponent } from '../../messages/message-view/message-view.component';

@Component({
  selector: 'lfw-messages-page',
  templateUrl: './messages-page.component.html',
  styleUrls: ['./messages-page.component.css'],
  imports: [MessageViewComponent]
})
export class MessagesPageComponent {}
